import React from "react";

export default function ScreenCapturePanelReview(
{
    issues,
    hoveredId,
    setHoveredId,
    hasCoordinates
})
{
    function getPriorityColour(priority)
    {
        if (!priority)
        {
            return "#888";
        }

        switch (priority.toLowerCase())
        {
            case "low":
                return "#4CAF50";

            case "medium":
                return "#FFC107";

            case "high":
                return "#FF9800";

            case "critical":
                return "#F44336";

            default:
                return "#888";
        }
    }
	
	
	
	const summary =
	{
	    low: 0,
	    medium: 0,
	    high: 0,
	    critical: 0
	};

	issues.forEach(function(issue)
	{
	    if (!issue.priority)
	    {
	        return;
	    }

	    switch (issue.priority.toLowerCase())
	    {
	        case "low":
	            summary.low++;
	            break;

	        case "medium":
	            summary.medium++;
	            break;

	        case "high":
	            summary.high++;
	            break;

	        case "critical":
	            summary.critical++;
	            break;

	        default:
	            break;
	    }
	});

    return (

        <div
            style={{
                width: "360px",
                background: "#111",
                color: "#fff",
                padding: "20px",
                overflowY: "auto"
            }}
        >

            <div
                style={{
                    fontSize: "20px",
                    marginBottom: "4px"
                }}
            >
                Compliance Review
            </div>

			<div
			    style={{
			        fontSize: "12px",
			        color: "#888",
			        marginBottom: "18px"
			    }}
			>
			    AI generated compliance observations
			</div>

			<div
			    style={{
			        display: "grid",
			        gridTemplateColumns: "1fr 1fr",
			        gap: "8px",
			        marginBottom: "22px"
			    }}
			>

			    <div
			        style={{
			            background: "#171717",
			            borderRadius: "8px",
			            padding: "10px"
			        }}
			    >
			        <div
			            style={{
			                color: "#F44336",
			                fontWeight: "bold",
			                fontSize: "20px"
			            }}
			        >
			            {summary.critical}
			        </div>

			        <div
			            style={{
			                color: "#888",
			                fontSize: "11px"
			            }}
			        >
			            Critical
			        </div>
			    </div>

			    <div
			        style={{
			            background: "#171717",
			            borderRadius: "8px",
			            padding: "10px"
			        }}
			    >
			        <div
			            style={{
			                color: "#FF9800",
			                fontWeight: "bold",
			                fontSize: "20px"
			            }}
			        >
			            {summary.high}
			        </div>

			        <div
			            style={{
			                color: "#888",
			                fontSize: "11px"
			            }}
			        >
			            High
			        </div>
			    </div>

			    <div
			        style={{
			            background: "#171717",
			            borderRadius: "8px",
			            padding: "10px"
			        }}
			    >
			        <div
			            style={{
			                color: "#FFC107",
			                fontWeight: "bold",
			                fontSize: "20px"
			            }}
			        >
			            {summary.medium}
			        </div>

			        <div
			            style={{
			                color: "#888",
			                fontSize: "11px"
			            }}
			        >
			            Medium
			        </div>
			    </div>

			    <div
			        style={{
			            background: "#171717",
			            borderRadius: "8px",
			            padding: "10px"
			        }}
			    >
			        <div
			            style={{
			                color: "#4CAF50",
			                fontWeight: "bold",
			                fontSize: "20px"
			            }}
			        >
			            {summary.low}
			        </div>

			        <div
			            style={{
			                color: "#888",
			                fontSize: "11px"
			            }}
			        >
			            Low
			        </div>
			    </div>

			</div>

            {issues.length === 0 && (

                <div
                    style={{
                        color: "#999",
                        fontSize: "13px"
                    }}
                >
                    No observations identified.
                </div>

            )}

            {issues.map(function(issue)
            {
                const colour =
                    getPriorityColour(issue.priority);

                return (

                    <div
                        key={issue.id}
                        onMouseEnter={function()
                        {
                            setHoveredId(issue.id);
                        }}
                        onMouseLeave={function()
                        {
                            setHoveredId(null);
                        }}
                        style={{
                            padding: "12px 0",
                            borderBottom: "1px solid #333",
                            cursor: "pointer",
                            background:
                                hoveredId === issue.id
                                    ? "#1a1a1a"
                                    : "transparent",
                            transition: "all 0.2s ease"
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >

                            <div
                                style={{
                                    fontWeight: "bold",
                                    color:
                                        hoveredId === issue.id
                                            ? "#5a9bd6"
                                            : "#fff"
                                }}
                            >
                                {issue.title}
                            </div>

                            <div
                                style={{
                                    fontSize: "11px",
                                    color: "#aaa",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {Math.round(issue.confidence * 100)}%
                            </div>

                        </div>

                        {issue.category && (

                            <div
                                style={{
                                    marginTop: "6px",
                                    fontSize: "12px",
                                    color: "#9aa7b1"
                                }}
                            >
                                {issue.category}
                            </div>

                        )}

                        {issue.priority && (

                            <div
                                style={{
                                    display: "inline-block",
                                    marginTop: "8px",
                                    padding: "3px 8px",
                                    borderRadius: "999px",
                                    background: colour + "22",
                                    color: colour,
                                    fontSize: "12px",
                                    fontWeight: "bold"
                                }}
                            >
                                {issue.priority}
                            </div>

                        )}

                        {issue.observation && (

                            <div
                                style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    color: "#ccc",
                                    lineHeight: "1.4"
                                }}
                            >
                                {issue.observation}
                            </div>

                        )}

                        {issue.recommendation && (

                            <div
                                style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    color: "#9bcfff",
                                    lineHeight: "1.4"
                                }}
                            >
                                Recommendation: {issue.recommendation}
                            </div>

                        )}

                        {!hasCoordinates(issue) && (

                            <div
                                style={{
                                    marginTop: "8px",
                                    fontSize: "11px",
                                    color: "#666"
                                }}
                            >
                                No hotspot coordinates returned
                            </div>

                        )}

                    </div>

                );

            })}

        </div>

    );
}